/** Sidebar sizes (px). The default width comes from the theme (`--sidebar-width`). */
export const SIDEBAR = {
  min: 200,
  max: 480,
  /** Icons-only rail. */
  rail: 64,
  /** Dragging narrower than this snaps to the rail. */
  snap: 150,
  /** Arrow-key step; Shift multiplies it. */
  step: 16,
} as const
